import React, { useState, useContext, useEffect } from "react";
import { SortableContainer, SortableElement } from "react-sortable-hoc";
import { RevisionesContext } from "../../context/RevisionesContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { ChecklistContext } from "../../context/ChecklistContext";
import { AdjuntosContext } from "../../context/AdjuntosContext";
import { ModalContext } from "../../context/ModalContext";
import EvidenciaForm from "../items/EvidenciaForm";
import ItemRowForm from "../items/ItemRowForm";
import ItemForm from "../items/ItemForm";
import ItemRow from "../items/ItemRow";
import arrayMove from "array-move";
import { ItemsContext } from "../../context/ItemsContext";
import "../../css/ChecklistSection.css";
import moment from "moment";
import { getSectionItems } from "../../utils/checklists";
import ChecklistSectionForm from "../checklistsection/ChecklistSectionForm";
import Folder from "../../views/Folder";
import useProyecto from "../../hooks/useProyecto";
import { CapacitorContext } from "../../context/CapacitorContext";
import useChecklists from "../../hooks/useChecklists";
import {
  IonItemSliding,
  IonItem,
  IonLabel,
  IonItemOptions,
  IonItemOption,
  IonList,
} from "@ionic/react";

const ChecklistSection = ({
  section,
  idSection,
  handleCallback,
}) => {
  const [showItems, setShowItems] = useState(false);
  const { idProyecto } = useProyecto();
  const {
    query,
    estado,
    editMode,
    checklist,
    expandAll,
    getSingleChecklist,
    postChecklistSection,
    deleteChecklistSection,
  } = useContext(ChecklistContext);

  const { handleComments, handleCreateItem } = useChecklists();

  const { idChecklist } = checklist;

  const {
    items,
    setItem,
    deleteItem,
    itemsByRevision,
    setPropertyItem,
    putChecklistItems,
    getItemsByRevision,
  } = useContext(ItemsContext);

  const { uploadSingleAdjunto } = useContext(AdjuntosContext);
  const { platform } = useContext(CapacitorContext);

  const { alert } = useContext(ModalContext);

  const { revision, updateItemByRevision, addItemToRevision } =
    useContext(RevisionesContext);
  const { proyecto } = useContext(ProyectosContext);
  const { confirm, clearModal, modalComponent } = useContext(ModalContext);

  useEffect(() => {
    getItemsByRevision(revision?.idRevision, idProyecto);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [revision]);

  useEffect(() => {
    setShowItems(expandAll);
  }, [expandAll]);

  const handleComplete = (idItem, completed) => {
    // completeItem(idProyecto, idItem, idChecklist, handleCallback);
    const itemOnRev = findItemOnRevision(idItem);
    const idRevisionItem = itemOnRev?.idRevisionItem;

    const revisionUpdated = {
      completedAt: moment().format(),
    };

    if (completed) revisionUpdated.completedAt = null;
    if (itemOnRev) {
      updateItemByRevision(idProyecto, idRevisionItem, revisionUpdated);
    } else {
      alert("Es necesario adjuntar evidencia para completar");
    }
  };

  const findItemOnRevision = (idItem) => {
    const itemOnRev = itemsByRevision?.find((obj) => {
      return obj.idItem === idItem;
    });

    return itemOnRev;
  };

  const handleCancel = () => {
    clearModal();
    getSingleChecklist(idProyecto, idChecklist);
  };

  const handleEditSection = () => {
    modalComponent(
      "Editar Sección",
      <ChecklistSectionForm
        section={section}
        idProyecto={idProyecto}
        idChecklist={idChecklist}
        handleCancel={handleCancel}
        postItem={postChecklistSection}
        idChecklistSection={section.idChecklistSection}
      />
    );
  };

  const handleEdit = (item) => {
    setItem(item);
    modalComponent(
      "Editar Item",
      <ItemForm
        idProyecto={idProyecto}
        idChecklist={idChecklist}
        handleCancel={handleCancel}
      />
    );
  };

  const handleUpload = (item) => {
    setItem(item);
    const itemRev = findItemOnRevision(item.idItem);
    if (itemRev) {
      return modalComponent(
        "Evidencias",
        <Folder idFolder={itemRev.idFolder} hideFolderButton />
      );
    }
    modalComponent(
      "Agregar Evidencia",
      <EvidenciaForm
        item={item}
        handleCancel={handleCancel}
        handleSubmit={(item, file) =>
          handleUploadEvidencia(idProyecto, item, file)
        }
      />
    );
  };

  const handleUploadEvidencia = async (idProyecto, item, file) => {
    const itemRev = findItemOnRevision(item.idItem);
    const itemData = {
      idItem: item.idItem,
      estado: item.estado,
    };

    if (itemRev) {
      uploadSingleAdjunto(idProyecto, itemRev.idFolder, file);
    } else {
      const { data } = await addItemToRevision(idProyecto, itemData, revision);
      uploadSingleAdjunto(data.idFolder, file);
    }
  };

  const handleDeleteSection = () => {
    confirm(
      `¿Estás seguro que deseas eliminar la sección ${section.nombre}? Esta acción NO puede deshacerse y todos los items serán eliminados.`,
      () =>
        deleteChecklistSection(
          idProyecto,
          idChecklist,
          section.idChecklistSection
        )
    );
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex !== newIndex) {
      const newItems = arrayMove(items, oldIndex, newIndex).map(
        (item, index) => {
          return { ...item, idItem: index + 1 };
        }
      );
      putChecklistItems(idProyecto, newItems, handleCancel);
    }
  };

  const SortableItem = SortableElement(({ item }) => {
    let CustomComponent = editMode ? ItemRowForm : ItemRow;
    return (
      <CustomComponent
        item={item}
        focused={item}
        key={item.idItem}
        handleEdit={handleEdit}
        idProyecto={idProyecto}
        deleteItem={deleteItem}
        permiso={proyecto.permiso}
        handleUpload={handleUpload}
        completeItem={handleComplete}
        handleCallback={handleCallback}
        handleComments={handleComments}
        setPropertyItem={setPropertyItem}
      />
    );
  });

  const SortableList = SortableContainer(({ items, isEditable }) => {
    return (
      <div>
        {items.map((item, index) => (
          <SortableItem
            key={`item-${item.idItem}`}
            index={index}
            item={item}
            disabled={!isEditable}
          />
        ))}
      </div>
    );
  });

  const renderItems = () => {
    if (Array.isArray(items) && showItems) {
      let itemsRender = getSectionItems(
        items,
        section.idChecklistSection,
        query
      );
      itemsRender = itemsRender.filter(
        (item) => String(item.idItem)[0] !== "d"
      );
      if (itemsRender.length === 0 && !editMode) {
        return <p className="mb-0 p-2">No hay items registrados.</p>;
      }
      if (estado !== "todo" && estado !== null) {
        itemsRender = itemsRender.filter((item) => {
          if (estado === "bueno") {
            return item.estado > 6;
          }
          return item.estado !== null && item.estado < 7;
        });
      }
      return (
        <SortableList
          lockAxis="y"
          items={itemsRender}
          onSortEnd={onSortEnd}
          isEditable={editMode}
        />
      );
    }
  };

  const sectionHeader = (
    <IonItemSliding>
      <IonItem
        button
        detail={false}
        onClick={() => setShowItems(!showItems)}
        style={{
          "--background": "#f8f9fa",
          "--border-color": "#e8e8e8",
          "--border-width": "0 0 1px 0",
          "--padding-start": "0",
          "--inner-padding-end": "8px",
          borderLeft: "3px solid #b76d4f",
        }}
      >
        <IonLabel className="ion-text-wrap">
          <div className="d-flex align-items-center gap-2 px-3 py-1">
            <i
              className={`fa fa-chevron-${showItems ? "down" : "right"}`}
              style={{ width: 14, color: "#b76d4f" }}
            ></i>
            <span className="fw-semibold small">{section.nombre}</span>
          </div>
        </IonLabel>
        <div
          slot="end"
          className="d-flex gap-1 pe-1"
          onClick={(e) => {
            e.stopPropagation();
            handleCreateItem(section.idChecklistSection);
          }}
        >
          <button className="btn btn-sm btn-outline-primary">
            <i className="fa fa-plus"></i>
          </button>
        </div>
      </IonItem>
      <IonItemOptions side="end">
        <IonItemOption color="medium" onClick={handleEditSection}>
          <i className="fa fa-edit"></i>
        </IonItemOption>
        <IonItemOption color="danger" onClick={handleDeleteSection}>
          <i className="fa fa-trash"></i>
        </IonItemOption>
      </IonItemOptions>
    </IonItemSliding>
  );

  if (platform === "web") {
    return (
      <IonList lines="none" className="ion-no-padding mb-1">
        {sectionHeader}
        {showItems && (
          <div className="checklist-section__body ps-3">
            {renderItems()}
          </div>
        )}
      </IonList>
    );
  } else {
    return (
      <IonList lines="full" className="ion-no-padding mb-1">
        {sectionHeader}
        {showItems && (
          <div className="checklist-section__body">
            {renderItems()}
          </div>
        )}
      </IonList>
    );
  }
};

export default ChecklistSection;
